<div class="instanceAction instanceReportsActionContainer dropdown d-flex align-items-center relative" [ngClass]="{'top-1': !isFromClearance}" *transloco="let translateMsg">
    <button *ngIf="searchableIndexFields?.includes(column)" [title]="translateMsg('Aggregations')" [matMenuTriggerFor]="aggregationMenu" #matReportsMenuTrigger="matMenuTrigger" (click)="prepareAggregationsByDataType()">
        <span class="material-icons material-symbols-outlined">
            calculate
        </span>
    </button>
    <mat-menu #aggregationMenu="matMenu" class="py-1 instanceReportsMenu !bg-white" backdropClass="bulkReportMenu" stop-propagation xPosition="before">
        <ng-container>
            <div class="m-2.5 flex items-center space-x-4" *ngFor="let aggregation of aggregationsData">
                <span class="flex-1 reportsList" [title]="aggregation.displayName" stop-propagation [textContent]="aggregation.displayName">
                </span>
                <span class="text-center truncate w-36" [title]="aggregation.value" stop-propagation [textContent]="aggregation?.value ?? '--'">
                </span>
                <span class="flex justify-center items-center text-center" stop-propagation>
                    <mat-icon class="instanceIconReportCls" [title]="translateMsg('Get Aggergation')" (click)="getAggregations(aggregation.name)">
                        autorenew
                    </mat-icon>
                </span>
            </div>
        </ng-container>
    </mat-menu>
</div>
